/* ==========================================================================
   通用居中弹窗开合（契约 C）—— 2026-08-26 quick-view 稿 V0DUwe7bwKFnumOjcXPTPR
   ==========================================================================
   骨架 snippets/amada-modal.liquid，样式 assets/amada-modal.css。
   与 assets/amada-drawer.js 是同一套设计的两个方向（右侧滑出 / 居中弹出），
   API 刻意一一对应，业务侧换个词就能切换形态。

   对外 API（window.AmadaModal）：
     open(id)      打开（可叠在抽屉之上；弹窗自身用栈管理，可以嵌套）
     close(id)     关闭；不传 id 关栈顶那个
     closeAll()    关掉所有
     isOpen(id)    是否打开；不传 id 表示「有没有任何弹窗开着」
   事件：弹窗根元素上派发 amada:modal:open / amada:modal:close（冒泡），
        detail = { id }。quick view 靠它切换抽屉标题 QUICK VIEW ↔ PRODUCT DETAILS。

   触发器：任意元素 data-amada-modal-open="<id>"（document 级委托，
   动态插入的 DOM 也能用 —— quick view 的弹窗是 AJAX 回来后才进 DOM 的，必须走委托）。
   关闭：data-amada-modal-close / 遮罩 / ESC。

   ⚠️ 两条与抽屉原语共存的关键点（不遵守就会「关弹窗顺带把抽屉也关了」）：
   1. click 委托注册在**捕获阶段**（第三参 true），和抽屉一致。
      主题自己也给一堆锚点绑了 modal 相关监听，冒泡阶段会被它抢先 stopPropagation。
   2. ESC 用**捕获阶段**监听，并在自己处理掉之后 stopImmediatePropagation()。
      amada-drawer.js 的 ESC 监听挂在 document 的**冒泡**阶段；
      keydown 的目标是焦点元素，捕获 document → … → target → 冒泡回 document，
      所以捕获阶段的我们必然先跑；不掐断的话同一次 ESC 会先关弹窗再关抽屉。
   ========================================================================== */
(function () {
  'use strict';
  /* 2026-10-06：只执行一次。快速预览资源改为全站加载（购物车抽屉推荐「+」开快速预览），
     PDP / 分类页自己也会挂同一个文件 → 同一页出现两个 <script src>，第二份直接让位，
     否则事件委托会绑两遍（点一次触发两次）。 */
  if (window.__amadaModalLoaded) return;
  window.__amadaModalLoaded = true;

  var OPEN_CLASS = 'is-open';
  var LOCK_CLASS = 'amada-modal-open';
  var TRANSITION_MS = 200; // 与 CSS 的 .2s 保持一致

  /** 打开中的弹窗 id 栈（后进先出）；允许弹窗上再开弹窗（learn more 开在 overview 之上） */
  var stack = [];
  /** 每个 id 打开前的焦点元素，关闭后还回去（可访问性） */
  var lastFocused = {};
  /** 关闭动画的定时器（按 id 存），避免连点时把刚打开的弹窗 hidden 掉 */
  var hideTimers = {};

  /** 属性选择器里 id 可能带引号等字符，做最小转义（不引入 polyfill 依赖） */
  function cssEscape(value) {
    return String(value).replace(/["\\]/g, '\\$&');
  }

  function root(id) {
    if (!id) return null;
    return document.querySelector('[data-amada-modal="' + cssEscape(id) + '"]');
  }

  function lockScroll() {
    document.documentElement.classList.add(LOCK_CLASS);
  }

  function unlockScroll() {
    document.documentElement.classList.remove(LOCK_CLASS);
  }

  function emit(el, name, id) {
    el.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { id: id } }));
  }

  function indexOf(id) {
    for (var i = 0; i < stack.length; i++) {
      if (stack[i] === id) return i;
    }
    return -1;
  }

  function open(id) {
    var el = root(id);
    if (!el) return false;
    if (indexOf(id) !== -1) return true; // 已经开着

    if (hideTimers[id]) {
      window.clearTimeout(hideTimers[id]);
      delete hideTimers[id];
    }

    lastFocused[id] = document.activeElement;

    el.hidden = false;
    /* 叠层：栈里第 n 个弹窗比第 n-1 个高 2（遮罩 + 面板各留一层），
       这样「弹窗上再开弹窗」时后开的一定在上面。基数 700 与 CSS 保持一致。 */
    el.style.zIndex = String(700 + stack.length * 2);

    // 先落一帧再加 is-open，否则起始态与结束态同帧、过渡不触发
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        el.classList.add(OPEN_CLASS);
      });
    });

    el.setAttribute('aria-hidden', 'false');
    lockScroll();
    stack.push(id);

    var closeBtn = el.querySelector('.amada-modal__close');
    if (closeBtn) closeBtn.focus();

    emit(el, 'amada:modal:open', id);
    return true;
  }

  function close(id) {
    var targetId = id || stack[stack.length - 1];
    if (!targetId) return;
    var el = root(targetId);
    if (!el) return;

    var at = indexOf(targetId);
    if (at !== -1) stack.splice(at, 1);

    el.classList.remove(OPEN_CLASS);
    el.setAttribute('aria-hidden', 'true');

    /* 只有栈空了才解锁滚动 —— 否则「关掉上层弹窗」会把下层弹窗/抽屉的锁一起解掉，
       表现是身后的页面突然能滚了。抽屉自己的锁（amada-drawer-open）与这里无关。 */
    if (!stack.length) unlockScroll();

    // 等淡出动画结束再 hidden，否则看不到退出动画（铁律 23 的「退出动画结束」状态）
    hideTimers[targetId] = window.setTimeout(function () {
      if (!el.classList.contains(OPEN_CLASS)) {
        el.hidden = true;
        el.style.removeProperty('z-index');
      }
      delete hideTimers[targetId];
    }, TRANSITION_MS);

    var back = lastFocused[targetId];
    if (back && typeof back.focus === 'function' && document.contains(back)) {
      back.focus();
    }
    delete lastFocused[targetId];

    emit(el, 'amada:modal:close', targetId);
  }

  function closeAll() {
    // 复制一份再遍历：close() 会改 stack
    var ids = stack.slice().reverse();
    for (var i = 0; i < ids.length; i++) close(ids[i]);
  }

  function isOpen(id) {
    return id ? indexOf(id) !== -1 : stack.length > 0;
  }

  /* ── 事件委托：触发器与关闭（捕获阶段，理由见文件头） ───────────────── */
  document.addEventListener(
    'click',
    function (e) {
      var target = e.target;
      if (!target || !target.closest) return;

      var opener = target.closest('[data-amada-modal-open]');
      if (opener) {
        var id = opener.getAttribute('data-amada-modal-open');
        if (id && root(id)) {
          e.preventDefault();
          /* 掐断后续监听：这些触发器有的同时是 <a href>（Size Guide 保留了降级跳转），
             主题也给它们绑了自己的 modal 逻辑，不掐断会「弹窗 + 主题弹窗」同时在场。 */
          if (e.stopImmediatePropagation) e.stopImmediatePropagation();
          open(id);
          return;
        }
      }

      var closer = target.closest('[data-amada-modal-close]');
      if (closer) {
        var host = closer.closest('[data-amada-modal]');
        if (host) {
          e.preventDefault();
          if (e.stopImmediatePropagation) e.stopImmediatePropagation();
          close(host.getAttribute('data-amada-modal'));
        }
      }
    },
    true
  );

  document.addEventListener(
    'keydown',
    function (e) {
      if (e.key !== 'Escape' || !stack.length) return;
      close(stack[stack.length - 1]);
      /* 必须掐断：否则同一次 ESC 会继续冒泡到 amada-drawer.js 的 document 监听，
         把身后的抽屉也关掉（实测过，表现是「按一次 ESC 全没了」）。 */
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      e.preventDefault();
    },
    true
  );

  window.AmadaModal = {
    open: open,
    close: close,
    closeAll: closeAll,
    isOpen: isOpen
  };
})();
